import React from 'react'

export type SuperLogoProps = {
  variant: 'symbol' | 'wordmark' | 'gradientRound'
}

function WordMark(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 92 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M55.8221 9.80047C55.8221 14.2155 51.8923 18.2411 47.5733 18.2411C44.2553 18.2411 41.8456 15.7552 41.8456 12.3234C41.8456 7.90829 45.7753 3.88278 50.0943 3.88278C53.4123 3.88278 55.8221 6.36858 55.8221 9.80047ZM53.9685 11.0433C53.9685 8.11234 51.6884 5.73785 48.8709 5.73785C46.0534 5.73785 43.6992 8.168 43.6992 11.0804C43.6992 13.9929 45.9792 16.386 48.7968 16.386C51.6143 16.386 53.9685 13.9558 53.9685 11.0433ZM52.4856 12.3234C52.4856 13.7518 51.5216 14.7164 50.0572 14.7164C47.6846 14.7164 45.1821 12.1935 45.1821 9.80047C45.1821 8.37205 46.146 7.40741 47.6104 7.40741C49.9831 7.40741 52.4856 9.93029 52.4856 12.3234ZM38.4719 24.6039H43.4026V18.612C44.7187 20.0219 46.6836 20.8196 48.8153 20.8196C54.1723 20.8196 57.9909 16.7941 57.9909 11.1361C57.9909 5.47814 54.1723 1.45264 48.8153 1.45264C46.6836 1.45264 44.7187 2.25032 43.4026 3.64162V1.86075H38.4719V24.6039ZM48.8338 12.8614C47.8513 12.8614 47.0357 12.0451 47.0357 11.0619C47.0357 10.0788 47.8329 9.26249 48.8338 9.26249C49.8348 9.26249 50.6318 10.0788 50.6318 11.0619C50.6318 12.0451 49.8534 12.8614 48.8338 12.8614Z"
          fill="currentColor"
        />
        <path
          d="M80.5682 1.79617H85.499V4.24486C86.5365 2.37124 88.7617 1.2582 91.0966 1.4808V6.00718C87.8533 5.52487 85.499 7.28718 85.499 10.1996V20.3469H80.5682V1.79617ZM18.3041 13.1863V1.79617H23.2348V12.4999C23.2348 15.3567 24.3655 16.7295 26.5158 16.7295C28.8329 16.7295 30.5752 14.8373 30.5752 12.3144V1.79617H35.5059V20.3469H30.5752V17.7498C29.4816 19.6234 27.3684 20.755 25.2182 20.755C20.8065 20.755 18.3041 18.0095 18.3041 13.1863Z"
          fill="currentColor"
        />
        <path
          d="M13.4012 10.4868C12.4744 9.95813 11.3344 9.53148 9.97385 9.20683C8.9914 8.93599 8.21102 8.68556 7.63082 8.45553C7.05063 8.2255 6.64097 7.98249 6.39629 7.72463C6.15161 7.46678 6.02926 7.17553 6.02926 6.85089C6.02926 6.36301 6.23873 5.97716 6.65765 5.69333C7.07658 5.4095 7.6753 5.26666 8.45569 5.26666C9.14897 5.26666 9.94416 5.41507 10.8413 5.71374C11.7366 6.0124 12.5467 6.43165 13.2696 6.97333L15.6997 3.64347C14.7451 2.93855 13.6404 2.39687 12.3818 2.01843C11.1249 1.64371 9.84774 1.45264 8.54653 1.45264C7.07102 1.45264 5.77717 1.69009 4.66498 2.16313C3.55279 2.63802 2.67046 3.2873 2.01797 4.11095C1.36734 4.93832 1.04295 5.89182 1.04295 6.97333C1.04295 8.05484 1.30246 9.01948 1.82334 9.77449C2.34421 10.5332 3.09494 11.1565 4.07923 11.6444C5.06166 12.1323 6.248 12.5515 7.63638 12.904C8.55952 13.1748 9.28984 13.4123 9.82556 13.6144C10.3613 13.8186 10.7357 14.0356 10.9526 14.2638C11.1695 14.4938 11.2769 14.785 11.2769 15.1375C11.2769 15.707 11.0175 16.1597 10.4966 16.4991C9.97571 16.8386 9.28242 17.0074 8.41491 17.0074C7.43248 17.0074 6.4278 16.8034 5.40088 16.3971C4.37581 15.9908 3.39708 15.4213 2.47397 14.6904L0.00305176 18.1C1.30431 19.022 2.64821 19.7028 4.03659 20.1499C5.42497 20.597 6.8838 20.8196 8.41491 20.8196C10.9006 20.8196 12.8322 20.2853 14.2038 19.2168C15.5774 18.1464 16.2633 16.7477 16.2633 15.0132C16.2633 14.0115 16.0186 13.1396 15.5256 12.3939C15.0324 11.6481 14.3262 11.0119 13.3994 10.4831V10.4887L13.4012 10.4868Z"
          fill="currentColor"
        />
        <path
          d="M77.1279 6.20347C76.3011 4.74167 75.1871 3.58411 73.7802 2.73078C72.3751 1.8793 70.7773 1.45264 68.9922 1.45264C67.2071 1.45264 65.637 1.8793 64.2042 2.73078C62.7714 3.58411 61.6351 4.74724 60.7953 6.22388C59.9556 7.69866 59.5386 9.34411 59.5386 11.1565C59.5386 12.9689 59.9705 14.6088 60.838 16.0687C61.7036 17.5324 62.8937 18.6881 64.41 19.5414C65.9244 20.3948 67.6298 20.8196 69.5223 20.8196C70.9849 20.8196 72.3492 20.5692 73.6189 20.0683C74.8887 19.5674 76.0267 18.8291 77.0278 17.8551L74.2677 14.8499C73.5632 15.527 72.8125 16.0224 72.0155 16.334C71.2166 16.6457 70.3453 16.8015 69.3981 16.8015C68.3694 16.8015 67.4574 16.5585 66.6585 16.0706C65.8595 15.5827 65.2256 14.9186 64.751 14.082C64.536 13.7035 64.3766 13.2954 64.258 12.8651H78.2011C78.2549 12.622 78.2956 12.3438 78.3235 12.0321C78.3494 11.7205 78.3642 11.4162 78.3642 11.1175C78.3642 9.30515 77.9509 7.66527 77.1279 6.20533H77.1297L77.1279 6.20347ZM64.2635 9.33112C64.3654 8.93785 64.5008 8.56498 64.6713 8.21623C65.0903 7.36289 65.6797 6.68765 66.436 6.18678C67.1942 5.68591 68.032 5.43548 68.9514 5.43548C69.9264 5.43548 70.7828 5.68591 71.528 6.18678C72.2732 6.68765 72.8589 7.35177 73.2927 8.17542C73.4835 8.53715 73.6301 8.92672 73.7375 9.33112H64.2635Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}

function SuperSymbol(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.97754 6.90918C7.5677 6.31338 8.52776 6.31354 9.11914 6.90918C9.71057 7.50639 9.71057 8.47429 9.11914 9.07031C8.52891 9.66712 7.56885 9.66728 6.97754 9.07031C6.385 8.47429 6.385 7.50639 6.97754 6.90918Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99707 4.83984C6.68317 3.09924 9.41762 3.09924 11.1025 4.83984C12.7897 6.58047 12.7898 9.40205 11.1025 11.1426C10.3128 11.9584 9.29249 12.3914 8.25781 12.4424C8.11988 12.4492 7.9817 12.4492 7.84375 12.4424C6.80891 12.3914 5.788 11.9584 4.99707 11.1426C3.30985 9.40202 3.3099 6.58047 4.99707 4.83984ZM9.82227 6.20605C8.42841 4.82146 6.50525 4.49789 5.52539 5.48242C4.54831 6.4694 4.88465 8.39099 6.27832 9.77539C7.06236 10.5541 8.01426 10.9971 8.87109 11.0605C9.06164 11.0746 9.24751 11.0698 9.42578 11.0459C9.87105 10.9861 10.2694 10.8066 10.5752 10.499C11.555 9.51222 11.216 7.59063 9.82227 6.20605Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00391 0.0117188C12.4128 0.0117188 15.9883 3.58605 15.9883 7.99609C15.9883 12.4062 12.414 15.9805 8.00391 15.9805C3.59387 15.9804 0.0195312 12.4061 0.0195312 7.99609C0.0195453 3.58606 3.59388 0.0117472 8.00391 0.0117188ZM12.3877 3.19336C10.1693 1.18836 6.42996 1.71062 4.03418 4.36035C3.6006 4.83917 3.23934 5.35777 2.9541 5.89453C1.87217 7.92736 1.86057 10.2424 2.9541 11.9053C3.16629 12.2264 3.41644 12.5235 3.71094 12.7891C5.92932 14.7928 9.66848 14.2708 12.0654 11.6211C14.4597 8.97149 14.6044 5.19839 12.3877 3.19336Z"
        fill="currentColor"
      />
    </svg>
  )
}
function SuperSymbolColored(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#a)">
        <rect width="48" height="48" fill="#232323" rx="24" />
        <g filter="url(#b)" opacity=".8">
          <circle cx="22.139" cy="60.555" r="76.614" fill="#176BE5" />
        </g>
        <g filter="url(#c)" opacity=".8">
          <circle
            cx="64.955"
            cy="79.621"
            r="70.903"
            fill="#EF91F7"
            transform="rotate(91.683 64.955 79.621)"
          />
        </g>
        <g clipPath="url(#d)">
          <mask
            id="e"
            width="32"
            height="32"
            x="8"
            y="8"
            maskUnits="userSpaceOnUse"
            style={{ maskType: 'luminance' }}
          >
            <path fill="#fff" d="M39.976 8.024H8.04V39.96h31.936V8.024Z" />
          </mask>
          <g fill="#fff" mask="url(#e)">
            <path
              fillRule="evenodd"
              d="M26.239 21.82a3.074 3.074 0 0 1 0 4.32 3.008 3.008 0 0 1-4.284 0 3.07 3.07 0 0 1 0-4.32 3.012 3.012 0 0 1 4.284 0Z"
              clipRule="evenodd"
            />
            <path
              fillRule="evenodd"
              d="M30.205 17.68c-3.37-3.482-8.839-3.482-12.211 0-3.374 3.48-3.374 9.123 0 12.604 3.375 3.482 8.841 3.482 12.21 0 3.375-3.48 3.375-9.123 0-12.605ZM29.15 28.996c-1.958 1.97-5.805 1.322-8.593-1.447-2.788-2.77-3.46-6.612-1.505-8.586 1.96-1.969 5.805-1.322 8.592 1.447 2.788 2.77 3.465 6.612 1.506 8.586Z"
              clipRule="evenodd"
            />
            <path d="M26.239 21.82a3.074 3.074 0 0 1 0 4.32 3.008 3.008 0 0 1-4.284 0 3.07 3.07 0 0 1 0-4.32 3.012 3.012 0 0 1 4.284 0Z" />
            <path d="M30.205 17.68c-3.37-3.482-8.839-3.482-12.211 0-3.374 3.48-3.374 9.123 0 12.604 3.375 3.482 8.841 3.482 12.21 0 3.375-3.48 3.375-9.123 0-12.605ZM29.15 28.996c-1.958 1.97-5.805 1.322-8.593-1.447-2.788-2.77-3.46-6.612-1.505-8.586 1.96-1.969 5.805-1.322 8.592 1.447 2.788 2.77 3.465 6.612 1.506 8.586Z" />
            <path
              fillRule="evenodd"
              d="M26.239 21.82a3.074 3.074 0 0 1 0 4.32 3.008 3.008 0 0 1-4.284 0 3.07 3.07 0 0 1 0-4.32 3.012 3.012 0 0 1 4.284 0Z"
              clipRule="evenodd"
            />
            <path
              fillRule="evenodd"
              d="M30.205 17.68c-3.37-3.482-8.839-3.482-12.211 0-3.374 3.48-3.374 9.123 0 12.604 3.375 3.482 8.841 3.482 12.21 0 3.375-3.48 3.375-9.123 0-12.605ZM29.15 28.996c-1.958 1.97-5.805 1.322-8.593-1.447-2.788-2.77-3.46-6.612-1.505-8.586 1.96-1.969 5.805-1.322 8.592 1.447 2.788 2.77 3.465 6.612 1.506 8.586Z"
              clipRule="evenodd"
            />
            <path d="M26.239 26.14a3.008 3.008 0 0 1-4.284 0 3.07 3.07 0 0 1 0-4.32 3.012 3.012 0 0 1 4.284 0 3.074 3.074 0 0 1 0 4.32Z" />
            <path
              fillRule="evenodd"
              d="M26.239 26.14a3.008 3.008 0 0 1-4.284 0 3.07 3.07 0 0 1 0-4.32 3.012 3.012 0 0 1 4.284 0 3.074 3.074 0 0 1 0 4.32Z"
              clipRule="evenodd"
            />
            <path d="M24.008 8.024c-8.82 0-15.968 7.148-15.968 15.968S15.188 39.96 24.008 39.96s15.968-7.148 15.968-15.968-7.15-15.968-15.968-15.968Zm8.122 23.218c-4.794 5.3-12.271 6.344-16.708 2.336a9.183 9.183 0 0 1-1.514-1.767c-2.188-3.326-2.164-7.956 0-12.021a15.236 15.236 0 0 1 2.161-3.069c4.792-5.299 12.269-6.345 16.706-2.335 4.434 4.01 4.144 11.557-.645 16.856Z" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <rect width="48" height="48" fill="#fff" rx="24" />
        </clipPath>
        <clipPath id="d">
          <path fill="#fff" d="M8 8h32v32H8z" />
        </clipPath>
        <filter
          id="b"
          width="193.082"
          height="193.082"
          x="-74.403"
          y="-35.986"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_30_1031"
            stdDeviation="9.964"
          />
        </filter>
        <filter
          id="c"
          width="205.808"
          height="205.808"
          x="-37.949"
          y="-23.282"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_30_1031"
            stdDeviation="16"
          />
        </filter>
      </defs>
    </svg>
  )
}

export function SuperLogo(
  props: React.SVGProps<SVGSVGElement> & SuperLogoProps
) {
  const { variant, ...otherProps } = props
  if (variant === 'symbol') {
    return <SuperSymbol {...otherProps} />
  } else if (variant === 'wordmark') {
    return <WordMark {...otherProps} />
  } else if (variant === 'gradientRound') {
    return <SuperSymbolColored {...otherProps} />
  }
  return null
}
